import React from 'react';
import InputMask from 'react-input-mask';

function TelefoneMaskInput({ value, onChange, ...rest }) {
    return (
        <InputMask
            mask="(99) 9999-9999"
            value={value}
            onChange={onChange}
        >
            {(inputProps) => <input {...inputProps} {...rest} className="form-control form-control-sm" />}
        </InputMask>
    );
}

export default TelefoneMaskInput;
